import React from 'react'
import { H1 } from '../common/H1'
export const PageNotFound = () => {
  return <H1>404 - Page not found</H1>
}
